import MainComponent from "components/Main";
import Avatar from "./Avatar";
import Rating from "./Rating";
import ButtonIconSelect from "./ButtonIconSelect";
import ButtonIcon from "./ButtonIcon";
import CheckBox from "./CheckBox";

import { ReactComponent as DragIcon } from 'icons/components/drag.svg';

export default class TableCells extends MainComponent {

    indexCell() {
        return <DragIcon />;
    }

    selectCell(id, map, info) {
        let { store, nameKey, emptyValue, translate, checkValueCb } = map;

        if (store?.toLowerCase)
            store = globalThis.appPageView.state[store] || this._config[store] || [];

        if (!id && emptyValue !== undefined)
            id = emptyValue;

        let item = store.find(it => it.id === id);
        if (!item)
            item = store.find(it => it.id === emptyValue);

        let value = item ? item[nameKey] : "";

        if (translate)
            value = this.tr(value);

        if (checkValueCb?.apply)
            return checkValueCb(value, map, info);

        return value;
    }

    rowsCell(value, { rows }, info) {
        return (rows || []).map((strOrObj, i) => {
            const { key, style, onClick, tooltip } = strOrObj || {};

            if (strOrObj?.toLowerCase) {
                const keys = strOrObj.trim().split(",");

                value = keys.map(field => {
                    return field.includes('.') ? field.trim().split('.').reduce((acc, part) => acc && acc[part], info) : info[field.trim()];
                }).join(" ");
            }
            else
                value = this.getTypeCell(key, strOrObj, info);

            const onClickEvent = onClick?.apply ? onClick.bind(null, info) : null;

            return (
                <div key={i} className={style || ""} onClick={onClickEvent} data-tooltip={tooltip}>{value}</div>
            );
        });
    }

    avatarCell(value, it, { sex }) {
        return <Avatar id={value} sex={sex} />;
    }

    ratingCell(value) {
        return <Rating value={value} />;
    }

    numberCell(value, { endStr }) {
        return (value || 0) + (endStr || "");
    }

    sumCell(value) {
        return value !== "" ? this._helper.number.toSum(value) : "";
    }

    booleanCell(value) {
        return this.tr("client", value ? "yes" : "no");
    }

    percentCell(value) {
        return ((value && value.toFixed(2)) || 0) + "%";
    }

    dateTimeCell(value, { useTz }) {
        return !value ? "" : this._helper.date.toDateTimeStr(value, useTz);
    }

    timePeriodCell(val, { keys }, info) {
        const arr = keys.map(key => {
            const value = info[key];
            return value ? this._helper.date.toTimeStr(value) : "";
        });

        return arr.join(" - ");
    }

    dateCell(value, { format }) {
        if (!value)
            return "";

        if (format)
            return this._helper.date.toStr(value, format);

        return this._helper.date.toDateStr(value);
    }

    clinicCell(value) {
        return value ? this._helper.getClinicNameById(value) : "";
    }

    phoneCell(value) {
        return this._helper.string.fromatPhone(value);
    }

    roleCell(value) {
        return this._helper.getRoleLabel(value);
    }

    specCell(value) {

        if (Array.isArray(value) && value.length > 0) {
            return value.map((it) => {
                return it.specEntity.title;
            }).join(", ");
        }
        return this.tr("employee.spec_none");
    }

    emp_statusCell(value) {

        return this._helper.getEmploeeStatusLabel(value);
    }

    emp_experienceCell(value) {
        return (value !== null) ? this._helper.getEmployeeExpirienceLabel(value.split("-")[0]) : "";
    }

    doctorCell(id, { short }) {
        const info = globalThis.appPageView.getDoctorById(id);
        return this._helper.string.formatFullName(info, short ? "short" : undefined);
    }

    employeCell(id, { short }) {
        const info = globalThis.appPageView.getEmployeById(id);
        return this._helper.string.formatFullName(info, short ? "short" : undefined);
    }

    clientCell(info, { short }) {
        return this._helper.string.formatFullName(info, short ? "short" : undefined);
    }

    teethCell(value) {
        return this._helper.getTeethNames(value).join(", ");
    }

    objectCell(value, { valueFormat }) {
        const obj = value || {};
        let val = valueFormat;
        (valueFormat.match(/\${(.*?)}/g) || []).forEach(str => {
            const key = str.replace("${", "").replace("}", "");
            val = val.replace(str, obj[key] || "");
        });

        return val;
    }

    arrayCell(value, { separator }) {
        return (value || []).join(separator || ", ");
    }

    iconCell(value, { name, tooltip, typeIcon, click }, info) {
        const cb = click?.apply ? click.bind(null, info) : null;

        return (
            <ButtonIcon
                name={name}
                tooltip={tooltip}
                translate={true}
                stopEvent={true}
                typeIcon={typeIcon}
                onClick={cb}
            />
        );
    }

    checkCell(value, { click, showNo }, info) {
        //const cb = click?.apply ? click.bind(null, info) : null;
        const clickCheck = () => {
            const val = this["checkBox" + info.id].value;
            this["checkBox" + info.id].value = !val;
            if (click?.apply)
                click("checkBox" + info.id, !val, info);
        };

        let show = true;

        if (showNo) {
            const stat = showNo[0];
            const { key, or, value: v } = stat;
            if (or(info[key], v))
                show = false;
        }

        return (show ? <CheckBox
            ref={el => this["checkBox" + info.id] = el}
            onClick={clickCheck.bind(this)}
        /> : false);
    }

    actionsCell(value, { items }, info) {
        const infOrig = { ...info };
        let paresedItems = items.map(it => {
            const onClickEvent = it.onClick?.apply ? it.onClick.bind(null, infOrig) : null;
            return { ...it, onClick: onClickEvent };
        });

        return (paresedItems.length > 0 ?
            <ButtonIconSelect
                name="dots"
                translate={true}
                stopEvent={true}
                items={paresedItems}
            /> : null
        );
    }

    getTypeCell(key, it, info) {
        const { type, emptyValue, callback } = it;
        const value = key.includes('.') ? key.trim().split('.').reduce((acc, part) => acc && acc[part], info) : info[key];

        if (callback?.apply)
            return callback(value, it, info, key);

        const typeFn = type + "Cell";
        if (this[typeFn]?.apply)
            return this[typeFn](value, it, info, key);

        return value || emptyValue || "";
    }

}
